<template>
  <div :class="$style.container" v-viewer="{ navbar: true }">
    <div
      v-for="message in messages" :key="message.id"
      :class="$style.item"
    >
      <img :src="message.attachment.link" alt="" :class="$style.image">
    </div>
    <infinite-loading
      :class="$style.infiniteLoading"
      @infinite="infiniteHandler"
    >
      <Spinner slot="spinner" />
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
  </div>
</template>

<script>
import { ATTACHMENT_CODE } from '@/models/Message'
import InfiniteLoading from 'vue-infinite-loading'
import Spinner from '@/components/Spinner'
import api from '@/api'

export default {
  name: 'profile-shared-photo',
  components: {
    InfiniteLoading,
    Spinner
  },
  props: {
    chat: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      page: 1,
      messages: []
    }
  },
  methods: {
    fetch () {
      return api.chats.mediaAttachments(this.chat.id, {
        type: ATTACHMENT_CODE['image'],
        page: this.page
      })
    },
    async infiniteHandler ($state) {
      const { data } = await this.fetch()
      if (data.length) {
        this.messages = this.messages.concat(data)
        $state.loaded()
        this.page += 1
      } else {
        $state.complete()
      }
    }
  }
}
</script>

<style module lang="scss">
.container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.item {
  flex-basis: 140px;
  height: 140px;
  margin: 2px;
  cursor: pointer;
}
.image {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.infiniteLoading {
  height: 50px;
  padding: 20px 0;
  margin: 0 auto;
  flex-basis: 100%;
}
</style>
